// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @ utils
const { formatText } = require('core/i18n').i18n;

// @ components
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');

// @ constants
const { MORTGAGE_PANEL } = require('../../../insuranceConstants/insuranceRequestRoutes');
const { WIZARD_REQUEST_RESPONSE_OPTIONS: { SUCCESS, ERROR, IS_FETCHING } } = require('../../../insuranceConstants/insuranceRequestHome');

function insuranceIdDraft(immInsuranceWizard, insuranceId, insuranceIsBeingModified) {
    let idDraft = null;
    if (insuranceIsBeingModified) {
        idDraft = immInsuranceWizard.get('visibleStep') === 2 && !insuranceId ? 0 : insuranceId;
    }
    return idDraft
}

function handleConfirmLeave(clearRequest, cancelingSimulation, immInsuranceWizard, insuranceId, insuranceIsBeingModified, isRnc, history) {
    cancelingSimulation(true);
    const insuranceIdDraftConst = insuranceIdDraft(immInsuranceWizard, insuranceId, insuranceIsBeingModified);
    clearRequest(insuranceIdDraftConst, isRnc);
    history.push(MORTGAGE_PANEL);
}

function onHandleBeforeLeaving(clearRequest, isRnc) {
    clearRequest(null, isRnc);
}

function isReady(immInsuranceWizard, insuranceIsBeingModified) {

    const isFirstStep = immInsuranceWizard.get('visibleStep') === 1;
    const wizardSuccess = immInsuranceWizard.get('wizardRequestResponse') === SUCCESS && !insuranceIsBeingModified;
    const wizardError = immInsuranceWizard.get('wizardRequestResponse') === ERROR;
    const wizardResponseIsFetching = immInsuranceWizard.get('wizardRequestResponse') === IS_FETCHING;
    return (
        wizardError ||
        wizardResponseIsFetching ||
        wizardSuccess ||
        isFirstStep
    );
}

const InsuranceRequestRelatedLeaveModalWrapper = ({
    immInsuranceWizard, clearRequest, cancelingSimulation, insuranceIsBeingModified, insuranceId, isPostAppraisalClosedPrice, isRnc, history }) => {

    const notClosedPriceAndBeingModified = isPostAppraisalClosedPrice === SUCCESS && insuranceIsBeingModified;
    const confirmationTitle = notClosedPriceAndBeingModified ? 'insuranceRequestHome-confirmationMessageTitleDraft' : 'insuranceRequestHome-confirmationMessageTitle';
    const confirmationMessage = notClosedPriceAndBeingModified ? 'insuranceRequestHome-confirmationMessageDraft' : 'insuranceRequestHome-confirmationMessage';

    return (
        <PreLeaveModalComponent
            confirmationMessage={formatText(confirmationMessage)}
            confirmationTitle={formatText(confirmationTitle)}
            acceptText={formatText('insuranceRequestHome-confirmationAcceptText')}
            cancelText={formatText('insuranceRequestHome-confirmationCancelText')}
            isReady={() => isReady(immInsuranceWizard, insuranceIsBeingModified)}
            onConfirmLeave={() => handleConfirmLeave(clearRequest, cancelingSimulation, immInsuranceWizard, insuranceId, insuranceIsBeingModified, isRnc, history)}
            beforeLeaving={() => onHandleBeforeLeaving(clearRequest, isRnc)}
        />
    )
};

InsuranceRequestRelatedLeaveModalWrapper.propTypes = {
    history: PropTypes.object.isRequired,
    immInsuranceWizard: PropTypes.object.isRequired,
    clearRequest: PropTypes.func.isRequired,
    cancelingSimulation: PropTypes.func.isRequired,
    insuranceIsBeingModified: PropTypes.bool,
    insuranceId: PropTypes.number,
    isPostAppraisalClosedPrice: PropTypes.string,
    isRnc: PropTypes.bool
};

InsuranceRequestRelatedLeaveModalWrapper.defaultProps = {
    insuranceIsBeingModified: false,
    insuranceId: null,
    isRnc: false,
};

module.exports = withRouter(InsuranceRequestRelatedLeaveModalWrapper);
